import React from 'react';
import { ListItem, ListItemText } from '@mui/material';
import classNames from 'classnames';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getDailies } from '../../state/fractals/dailies';
import DiscretizeLink from './Link';

const useStyles = makeStyles()((theme) => ({
  link: {
    color: `${theme.palette.common.white} !important`,
    transition: theme.transitions.create(['color', 'border-right'], {
      duration: theme.transitions.duration.short,
    }),
    borderRight: `2px solid transparent`,
    '&:hover': {
      borderRight: `2px solid ${theme.palette.primary.dark}`,
    },
  },
  activeLink: {
    color: `${theme.palette.primary.main} !important`,
    borderRight: `2px solid ${theme.palette.primary.main}`,
  },
  nested: {
    paddingLeft: `${theme.spacing(2)} !important`,
  },
  nestedItemText: {
    fontSize: '0.9rem',
    fontWeight: '300',
  },
}));

interface MenuItemProps {
  to: string;
  pathname: string;
  label: React.ReactNode;
  nested?: boolean;
  onClick?: () => void;
  fractalApi?: number;
  children?: React.ReactNode;
}

export default function MenuItem({
  pathname,
  to,
  label,
  nested,
  children,
  onClick,
  fractalApi,
}: MenuItemProps) {
  const { classes } = useStyles();
  const fractalDailies = useSelector(getDailies);

  return (
    <ListItem
      button
      component={to.includes('http') ? DiscretizeLink : Link}
      to={to}
      className={classNames(
        classes.link,
        pathname.includes(to) && classes.activeLink,
      )}
      onClick={onClick}
    >
      <ListItemText
        primary={label}
        classes={{
          root: nested ? classes.nested : undefined,
          primary: classNames(nested && classes.nestedItemText),
        }}
      />
      {children}
      {fractalDailies.includes(fractalApi) && (
        <StaticImage
          src="../../assets/images/icons/dailyfractals.png"
          alt="Daily Fractal Image"
          width={20}
          height={20}
        />
      )}
    </ListItem>
  );
}
